import { Instagram, Mail } from "lucide-react";
import { Label } from "./Motion";

export const Footer = ({ scrollTo }) => (
  <footer data-testid="footer" className="relative bg-[#2c2826] text-[#e7ddcf] pt-20 pb-10 pc-grain overflow-hidden">
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-[#413a33]">
        <div className="md:col-span-6">
          <div className="flex items-center gap-4">
            <img src="/logo.png" alt="Pageshier Casa" className="h-16 w-16 object-contain rounded-full bg-white" />
            <div>
              <p className="font-serif text-2xl text-[#F7F5F0]">Pageshier Casa</p>
              <p className="text-sm text-[#8b7e76] italic">Luxury lives here</p>
            </div>
          </div>
          <p className="mt-8 max-w-md font-serif text-3xl md:text-4xl leading-tight text-[#F7F5F0]">
            A story. Elegance. <span className="italic text-[#E8942E]">Home.</span>
          </p>
        </div>

        <div className="md:col-span-3">
          <Label className="text-[#8b7e76]">Explore</Label>
          <ul className="mt-5 space-y-3">
            {[["Manifesto", "manifesto"], ["Collection", "collection"], ["Hampers", "hampers"], ["Build a Hamper", "builder"]].map(([l, id]) => (
              <li key={id}>
                <button data-testid={`footer-${id}`} onClick={() => scrollTo(id)} className="text-[#c8beb4] hover:text-[#E8942E] transition-colors duration-300">{l}</button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <Label className="text-[#8b7e76]">Connect</Label>
          <ul className="mt-5 space-y-3">
            <li>
              <a data-testid="footer-email" href="mailto:pageshiercasa@gmail.com" className="inline-flex items-center gap-2 text-[#c8beb4] hover:text-[#E8942E] transition-colors duration-300">
                <Mail size={16} /> pageshiercasa@gmail.com
              </a>
            </li>
            <li>
              <a data-testid="footer-instagram" href="https://instagram.com" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-[#c8beb4] hover:text-[#E8942E] transition-colors duration-300">
                <Instagram size={16} /> Instagram
              </a>
            </li>
            <li>
              <button data-testid="footer-enquire" onClick={() => scrollTo("enquire")} className="rounded-full border border-[#413a33] px-5 py-2.5 text-sm text-[#F7F5F0] hover:bg-[#985F47] hover:border-[#985F47] transition-colors duration-300 mt-2">
                Enquire now
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-[#8b7e76]">
        <p>&copy; {new Date().getFullYear()} Pageshier Casa. All rights reserved.</p>
        <p>Cushion covers &middot; Candles &middot; Vases &middot; Hampers</p>
      </div>
    </div>
  </footer>
);
